var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 29.3327C23.3639 29.3327 29.3334 23.3631 29.3334 15.9993C29.3334 8.63555 23.3639 2.66602 16.0001 2.66602C8.63628 2.66602 2.66675 8.63555 2.66675 15.9993C2.66675 23.3631 8.63628 29.3327 16.0001 29.3327Z",
    stroke: "#395BA9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 11.9531C12.6667 11.3167 12.6667 10.9986 12.7997 10.8209C12.9156 10.6661 13.093 10.5693 13.2859 10.5555C13.5073 10.5397 13.7749 10.7117 14.3102 11.0559L20.6043 15.1021C21.0689 15.4007 21.3011 15.55 21.3813 15.7399C21.4514 15.9058 21.4514 16.0929 21.3813 16.2588C21.3011 16.4487 21.0689 16.598 20.6043 16.8966L14.3102 20.9428C13.7749 21.287 13.5073 21.459 13.2859 21.4432C13.093 21.4294 12.9156 21.3326 12.7997 21.1778C12.6667 21.0001 12.6667 20.682 12.6667 20.0456V11.9531Z",
    stroke: "#395BA9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/PlayVideo.44e0678507c8a1908e9cb22768ff2bd6.svg";
export { ForwardRef as ReactComponent };